import { notificationActions } from './notification/notification-slice';
import { loadingActions } from './spinner/spinner-slice';
import { ROUTE_SKILL_SCHEDULER } from '../constants/routeConstants';


export const getData = (config) => {
    return async (dispatch) => {
        if (!config.fetchFn) return;
        if (!config.actions) return;
        if (!config.token) return;
        if (!config.dataKey) return;
        if (!config.setFunctionName) return;

        const name = config.name ? config.name : "unnamed";

        dispatch(loadingActions.startLoading());

        try {
            const data = await config.fetchFn(config.token);

            const dataObject = {
                dataValid: true
            };
            dataObject[config.dataKey] = data;

            console.count(`common-actions -> getData: ${name} request result`);
            console.table(data);

            dispatch(
            config.actions[config.setFunctionName](dataObject)
            );
        } catch (error) {
            if (error.name === "AbortError") {
                console.count(`common-actions -> getData: ${name} request was aborted, not invalidating data`);
            } else {
                dispatch(config.actions.invalidateData());
                dispatch(notificationActions.setError(error.message));
            }
        }

        dispatch(loadingActions.stopLoading());
    };
}

export const patchData = (config) => {
    return async (dispatch) => {
        if (!config.patchFn) return;
        if (!config.actions) return;
        if (!config.token) return;
        if (!config.dataKey) return;
        if (!config.setFunctionName) return;
        if (!config.patchData) return;

        const name = config.name ? config.name : "unnamed";

        dispatch(loadingActions.startLoading());

        try {
            await config.patchFn(config.token, config.patchData);

            const dataObject = {
                dataValid: true
            };
            dataObject[config.dataKey] = config.patchData;

            console.count(`common-actions -> patchData: ${name} request executed successfully`);

            dispatch(config.actions[config.setFunctionName](dataObject));
            dispatch(notificationActions.setSuccess(config.successMessage || "Patch operation executed successfully"));
        } catch (error) {
            //set data invalid
            dispatch(config.actions.invalidateData());
            dispatch(notificationActions.setError(error.message));
        }

        dispatch(loadingActions.stopLoading());
    };
}

export const updateItem = (config) => {
    return async (dispatch) => {
        if (!config.updateFn) return;
        if (!config.actions) return;
        if (!config.token) return;
        if (!config.dataKey) return;
        if (!config.actionFunctionName) return;
        if (!config.item) return;

        const name = config.name ? config.name : "unnamed";

        dispatch(loadingActions.startLoading());

        try {
            await config.updateFn(config.token, config.item);

            const dataObject = {
                dataValid: true,
                isSave: true
            };
            dataObject[config.dataKey] = config.item;

            console.count(`common-actions -> updateItem: ${name} request executed successfully`);

            dispatch(config.actions[config.actionFunctionName](dataObject));

            if (config.showConfirmation && config.confirmationFn) {
                dispatch(notificationActions.setSuccess(config.confirmationFn(config.item)));            
            }

        } catch (error) {
            //set data invalid
            if (!config.doNotInvalidate) dispatch(config.actions.invalidateData());
            dispatch(notificationActions.setError(error.message));
        }

        dispatch(loadingActions.stopLoading());
    }
}

export const createItem = (config) => {
    return async (dispatch) => {
        if (!config.createFn) return;
        if (!config.actions) return;
        if (!config.token) return;
        if (!config.dataKey) return;
        if (!config.actionFunctionName) return;
        if (!config.item) return;

        const name = config.name ? config.name : "unnamed";

        dispatch(loadingActions.startLoading());

        try {
            await config.createFn(config.token, config.item);

            const dataObject = {
                dataValid: true
            };
            dataObject[config.dataKey] = config.item;

            console.count(`common-actions -> createItem: ${name} request executed successfully`);

            dispatch(config.actions[config.actionFunctionName](dataObject));

            if (config.showConfirmation && config.confirmationFn) {
                dispatch(notificationActions.setSuccess(config.confirmationFn(config.item)));            
            }

            if (config.navigate) config.navigate(`${ROUTE_SKILL_SCHEDULER}/edit/${config.item.name}`);
        } catch (error) {
            //set data invalid
            dispatch(config.actions.invalidateData());
            dispatch(notificationActions.setError(error.message));
        } finally {
            dispatch(loadingActions.stopLoading());
        }
    }
}

export const deleteItem = (config) => {
    return async (dispatch) => {
        if (!config.deleteFn) return;
        if (!config.actions) return;
        if (!config.token) return;
        if (!config.dataKey) return;
        if (!config.actionFunctionName) return;
        if (!config.item) return;

        const name = config.name ? config.name : "unnamed";

        dispatch(loadingActions.startLoading());

        try {
            await config.deleteFn(config.token, config.item);

            const dataObject = {
                dataValid: true
            };
            dataObject[config.dataKey] = config.item;

            console.count(`common-actions -> deleteItem: ${name} request executed successfully`);

            dispatch(config.actions[config.actionFunctionName](dataObject));

            if (config.showConfirmation && config.confirmationFn) {
                dispatch(notificationActions.setSuccess(config.confirmationFn(config.item)));            
            }
        } catch (error) {
            //set data invalid
            dispatch(config.actions.invalidateData());
            dispatch(notificationActions.setError(error.message));
        }

        dispatch(loadingActions.stopLoading());
    }
}

export const executeItem = (config) => {
    return async (dispatch) => {
        if (!config.executeFn) return;
        if (!config.actions) return;
        if (!config.token) return;
        if (!config.name) return;

        const {name} = config;

        dispatch(loadingActions.startLoading());

        try {
            await config.executeFn(config.token, name);
            console.count(`common-actions -> createItem: request executed successfully`);
            if (config.navigate) config.navigate(`${ROUTE_SKILL_SCHEDULER}/edit/${name}`);
        } catch (error) {
            //set data invalid
            dispatch(notificationActions.setError(error.message));
        } finally {
            dispatch(config.actions.invalidateData());
            dispatch(loadingActions.stopLoading());
        }
    }
}